/**
 * Sentry configuration for self-hosted instance at sentry.goodnews.nl
 * Set GATSBY_SENTRY_DSN in your environment (e.g. https://xxx@sentry.goodnews.nl/41)
 */
import * as Sentry from '@sentry/gatsby';

const dsn = 'https://e26c1c4c85d93df65bb3b29ed1e42509@sentry.goodnews.nl/42';

// Debug: controleer of DSN beschikbaar is (verwijder na troubleshooting)
if (typeof window !== 'undefined') {
  // eslint-disable-next-line no-console
  console.log(
    '[Sentry] DSN:',
    dsn
      ? `${dsn.substring(0, 30)}...`
      : 'NIET GEVONDEN - check .env en herstart dev server',
  );
}

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.GATSBY_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    tracesSampleRate: 0.1,
    enabled: true,
  });
}
